// As chamadas da Fase W1: o login da equipe, a senha, a equipe e a auditoria (plugchef.admin.api,
// /admin/v1). O comercial (W2) fica em api/comercial.ts.
// Só funções finas sobre o `http` (api/client.ts) — o formato e a sessão são de lá.
import { http } from './client';
import type {
  AlteracaoMembro, FiltroAuditoria, MembroCriado, MembroEquipe, NovoMembro, RegistroAuditoria, RespostaLogin, SenhaProvisoria, TrocaSenha, UsuarioEu,
} from './tipos';

// ─── Login ──────────────────────────────────────────────────────────────────────────────────────

/** E-mail + senha (+ o código do autenticador, quando ele já está ativo). Rota pública. */
export function entrar(email: string, senha: string, codigo?: string): Promise<RespostaLogin> {
  return http.publico('/auth/login', { email, senha, ...(codigo ? { codigo } : {}) });
}

/** O 1º código do autenticador, com o desafio do login (vale 10 min). Abre a sessão. */
export function ativarTotp(desafio: string, codigo: string): Promise<RespostaLogin> {
  return http.publico('/auth/totp/ativar', { desafio, codigo });
}

/**
 * Quem está logado, lido de novo no servidor (o papel pode ter mudado), com o nível no suporte — que o
 * login e o renovar não trazem (a sessão o guarda daqui: store/sessao.tsx).
 */
export function eu(): Promise<UsuarioEu> {
  return http.get('/auth/eu');
}

// ─── Equipe ─────────────────────────────────────────────────────────────────────────────────────

export function listarEquipe(): Promise<MembroEquipe[]> {
  return http.get('/equipe');
}

export function criarMembro(dados: NovoMembro): Promise<MembroCriado> {
  return http.post('/equipe', dados);
}

export function alterarMembro(id: number, dados: AlteracaoMembro): Promise<{ id: number }> {
  return http.patch(`/equipe/${id}`, dados);
}

/** O celular foi perdido: derruba as sessões e o próximo login configura o autenticador de novo. */
export function zerarAutenticador(id: number): Promise<{ id: number }> {
  return http.post(`/equipe/${id}/zerar-autenticador`);
}

/** Derruba as sessões da pessoa (inclusive o acesso já emitido). A própria = 400 PROPRIA_SESSAO. */
export function encerrarSessoes(id: number): Promise<{ id: number }> {
  return http.post(`/equipe/${id}/encerrar-sessoes`);
}

/** Esqueceu a senha: uma provisória nova (aparece uma vez) e as sessões da pessoa caem. A própria = 422 PROPRIO_CADASTRO. */
export function gerarSenhaProvisoria(id: number): Promise<SenhaProvisoria> {
  return http.post(`/equipe/${id}/senha-provisoria`);
}

// ─── A própria senha ────────────────────────────────────────────────────────────────────────────

/** Troca a própria senha. Depois do 200 TODAS as sessões caíram, inclusive esta: o portal volta ao login. */
export function trocarSenha(dados: TrocaSenha): Promise<{ trocada: true }> {
  return http.post('/auth/senha', dados);
}

// ─── Auditoria ──────────────────────────────────────────────────────────────────────────────────

/**
 * As mais novas primeiro; `antes` = o id da última linha já vista (a página seguinte). `limite` 1–500. Filtra por
 * ação, pessoa, cliente e período (datas de Brasília, inclusive).
 */
export function listarAuditoria(filtro: FiltroAuditoria = {}): Promise<RegistroAuditoria[]> {
  return http.get('/auditoria', filtro);
}
